export default "__VITE_ASSET__BWjIHMN5__"